// extracted by mini-css-extract-plugin
module.exports = {"group_separator":"group_separator--XcYPz","line_separator":"line_separator--13Lnf"};